import React, { useEffect } from 'react';
import { connect } from 'react-redux'
import { SubHeader } from '../../components';

function SubHeaderContainerFn(props) {
    useEffect(() => {
       
    }, [])

    return (
      <>
        {/* SubHeader for all pages, with filters */}
        <SubHeader />
      </>
    );
}

const mapStateToProps = state => {
  return {
    
  }
}

const mapDispatchToProps = dispatch => {
  return {
    
  }
}

export const SubHeaderContainer = connect(mapStateToProps, mapDispatchToProps)(SubHeaderContainerFn)